import { Box } from '@mui/material';
import { Route, Switch, useRouteMatch } from 'react-router';
import { ScheduledAnnouncements } from './components/ScheduleAnnouncements';
import { SentAnnouncements } from './components/SentAnnouncements';
import { AnnouncementWizard } from './components/AnnouncementWizard';
import { SentAnnouncementSummary } from './components/SentAnnouncementSummary';

export const Announcements = () => {
  let { path } = useRouteMatch();
  return (
    <Box>
      <Switch>
        <Route exact path={path}>
          <ScheduledAnnouncements />
        </Route>
        <Route path={`${path}/:uuid/summary`}>
          <SentAnnouncementSummary />
        </Route>
        <Route path={`${path}/scheduled`}>
          <ScheduledAnnouncements />
        </Route>
        <Route path={`${path}/sent`}>
          <SentAnnouncements />
        </Route>
        <Route path={`${path}/:uuid`}>
          <AnnouncementWizard />
        </Route>
      </Switch>
    </Box>
  );
};
